import api from "./api";
import { Country } from "./Country";

export type ResetData = {
    token: string;
    newPassword: string;
  }

export enum USER_ROLES {
    ADMIN = "admin",
    ADMIN_COUNTRY = "admin-country",
    USER = "user"
}

export type User = {
    _id: string;
    name: string;
    password?: string;
    email: string;
    role?: string;
    accessToken?: string;
    country?: string | Country;
}

export const UserService = {
    
    login: function(email: string, password: string){
        return api.post(`auth/login/`, {email, password })
    },

    forgotPassword: function(email: string){
        return api.post(`auth/forgot-password/`, {email})
    },

    resetPassword: function(resetData: ResetData){
        return api.post(`auth/reset-password/`, resetData)
    },

    create: function(user: User){
        return api.post(`users/addUser`, user);
    }, 

    update: function(user: User){
        return api.patch(`users/${user._id}/`, user)
    },

    getAll: function(country?: string){
        if(country)
            return api.get(`users/?country=${country}`);
        return api.get(`users/`);
    },

    getById: function(id: string){
        return api.get(`users/${id}/`);
    },

    delete: function(id: string){
        return api.delete(`users/${id}/`)
    },
}

export function getCurrentUser(): User{
    return JSON.parse(localStorage.getItem("user")!);
}
export function setCurrentUser(user: User | undefined){
  localStorage.setItem("user", JSON.stringify(user));
}